function getAppVersion() {
    var browser = {
        versions: function () {
            var u = navigator.userAgent,
                app = navigator.appVersion,
                ua = navigator.userAgent.toLowerCase();
            //移动终端浏览器版本信息 
            return {
                mobile: !!u.match(/AppleWebKit.*Mobile.*/),
                ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
                android: (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 ? "Android" : false), //android终端或uc浏览器  
                iPhone: (u.indexOf('iPhone') > -1 ? "iPhone" : false),                             //是否为iPhone或者QQHD浏览器  
                wechat: (ua.match(/MicroMessenger/i) == "micromessenger" ? "micromessenger" : false),
                winPhone: (u.indexOf('Windows Phone') > -1 ? "winPhone" : false)  //winPhone 手机
            };
        }(),
        language: (navigator.browserLanguage || navigator.language).toLowerCase()
    }
    if (browser.versions.mobile) {
        if (browser.versions.wechat) {
            return "micromessenger";
        }
        if (browser.versions.android && !browser.versions.wechat) {
            return "Android";
        }
        if (browser.versions.iPhone && !browser.versions.wechat) {
            return "iPhone";
        }
    } else {
        if (browser.versions.wechat) {
            return "pcmicromessenger";
        }
    }
}

function extractVersion(uastring, expr, pos) {
    const match = uastring.match(expr)
    return match && match.length >= pos && parseInt(match[pos], 10)
}
export function detectBrowser() {
    // Returned result object.
    const result = { browser: null, version: null, mobile: null }

    // Fail early if it's not a browser
    if (typeof window === 'undefined' || !window.navigator) {
        result.browser = 'Not a browser.'
        return result
    }

    const { navigator } = window
    result.mobile = ('ontouchstart' in document.documentElement) || !!navigator.userAgent.match(/AppleWebKit.*Mobile.*/)
    if (navigator.mozGetUserMedia) { // Firefox.
        result.browser = 'firefox'
        result.version = extractVersion(navigator.userAgent,
            /Firefox\/(\d+)\./, 1)
    } else if (navigator.webkitGetUserMedia ||
        (window.isSecureContext === false && window.webkitRTCPeerConnection &&
            !window.RTCIceGatherer)) {
        result.browser = 'chrome'
        result.version = extractVersion(navigator.userAgent,
            /Chrom(e|ium)\/(\d+)\./, 2)
    } else if (navigator.mediaDevices &&
        navigator.userAgent.match(/Edge\/(\d+).(\d+)$/)) { // Edge.
        result.browser = 'edge'
        result.version = extractVersion(navigator.userAgent,
            /Edge\/(\d+).(\d+)$/, 2)
    } else if (window.RTCPeerConnection &&
        navigator.userAgent.match(/AppleWebKit\/(\d+)\./)) { // Safari.
        result.browser = 'safari'
        result.version = extractVersion(navigator.userAgent,
            /AppleWebKit\/(\d+)\./, 1)
        result.supportsUnifiedPlan = window.RTCRtpTransceiver &&
            'currentDirection' in window.RTCRtpTransceiver.prototype
    } else { // Default fallthrough: not supported.
        result.browser = 'Not a supported browser.'
        return result
    }

    return result
}


// let utlogMap = {
//     userId:'',
//     cookieId:'',
//     clientType:'pc/h5/mobile',
//     lang:'en-US/zh-CN',
//     url:'',
//     preUrl:'',
//     functionId:'',
//     eventType:'clk/pageOpen/loadTime/visitTime/search',
//     channel:'deepbone',
//     uuid:window.navigator.userAgent.replace(/[^\w]/gi, ''),//当前电脑浏览器的唯一标识
//     env:'dev'
// }

export function  newTerminalInfo(){ 
    var u = navigator.userAgent, app = navigator.appVersion; 
    const info = {  // 移动终端浏览器版本信息 
         trident: u.indexOf('Trident') > -1,  // IE内核
         presto: u.indexOf('Presto') > -1,    // Opera内核
         webKit: u.indexOf('AppleWebKit') > -1,  // 苹果、谷歌内核
         gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,  // 火狐内核
         mobile: !!u.match(/AppleWebKit.*Mobile.*/)||!!u.match(/AppleWebKit/)&&u.indexOf('QIHU')&&u.indexOf('Chrome')<0,  // 是否为移动终端  
         ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),  // iOS终端
         android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1,  // Android 终端或者 UC 浏览器
         iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1,  // 是否为 iPhone 或者 QQHD 浏览器
         iPad: u.indexOf('iPad') > -1,   // 是否 iPad
         webApp: u.indexOf('Safari') == -1,   // 是否WEB应该程序，没有头部与底部。
         ua:u 
    };
    if (!info.mobile) {
        return 'pc'
    } else { 
        return 'mobile'
    }
  }

  export function functionId(obj){
    return `${obj.pageName}_${obj.module}_${obj.func}`
  }

  export function getUrl(){
    return `${location.origin}/#`;
  }


  export function getCookie(cname) {
    var name = cname + '=';
    var ca = document.cookie.split(';'); 
    for (var i = 0; i < ca.length; i++) {
        if (ca[i].indexOf(name) >= 0) {
           return ca[i].split('=')[1];
            }
          }
          return '';
    }
  